export enum Status {
    Pending = 'pending',
    Cancelled = 'cancelled',
    Approved = 'approved',
    Declined = 'declined',
    Completed = 'completed',
}

export enum BookingType {
    OnBehalf = 'onBehalf',
    Guest = 'guest',
    Owner = 'owner',
}
